import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { StyledIconButton, styled } from "@iventis/styles";
import { Content } from "@iventis/translations";
import { useIventisTranslate } from "@iventis/translations/use-iventis-translate";

import { closeButton } from "@iventis/styles/src/atomic-rules";

interface CloseIconProps {
    onMouseDown: () => void;
    className?: string;
    dataTestId?: string;
}

/** An icon button which will display in top right of it's container */
export const CloseButton = ({ onMouseDown, className, dataTestId }: CloseIconProps) => {
    const translate = useIventisTranslate();

    return (
        // The button is only an icon, so it needs a name for assistive technology
        <StyledCloseButton className={className} onMouseDown={onMouseDown} data-testid={dataTestId} aria-label={translate(Content.common.buttons.close)}>
            <FontAwesomeIcon className="icon" icon={["far", "xmark"]} />
        </StyledCloseButton>
    );
};

const StyledCloseButton = styled(StyledIconButton)`
    position: absolute;
    top: 0px;
    right: 0px;
    .icon {
        height: ${closeButton.height};
        width: ${closeButton.width};
    }
`;
